export default __webpack_public_path__ + "static/media/inex1.5edf60d3.svg";